<template>
<div >
  <div class="form-group">
    <label for="store"><strong>SEDE</strong></label>
    <select id="store_select" :required="required" :disabled="!isActive" @change="$emit('update',storeId,items)" class="form-control" v-model="storeId" >
      <option v-if="optionBase" :value="0"> -- Seleziona una sede -- </option> 
      <option v-for="(item,index) in items" :value="item.storeId" :key="index">{{item.store}}</option>        
    </select>  
  </div>  
</div>


</template>
<script>
import api from '@/api'

import { mapGetters }    from 'vuex';

export default {
  props : ['isActive','required','optionBase','Id'] , 
  components: {},
  data() {
    return {

      storeId                : 0,
      items                  : [],
      spinner                : false,
      

   
    };
  },
  computed :{
    ...mapGetters(['company']),
   
  },
  mounted: function() {
    
  },
  created: function() {

  
      this.storeId = this.Id
      this.getData()
  },
  methods: 
  {
    async getData()
    {
        
      const sp   = {'sp'        : 'spStoresCompany'}      
      const data = {'companyId' : this.company.Id}
      const json  = Object.assign(data, sp);
      
      await api.post(json).then(res => {
          
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]      
              this.storeId = this.Id 
              
             
            }
           else if(res.status==500)
           {
                console.log(res.data)

                
                    
           } 
           else
            {
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });



    },
  
    
    
  
}

}
</script>
<style scoped>

</style>